export default __webpack_public_path__ + "static/media/diplome-frise2.186db37d.mp4";